export const handleScroll = (idToScrollTo: string, scrollBehavior?: ScrollBehavior) => {
  const element = document.getElementById(idToScrollTo);
  setTimeout(() => {
    window.scrollTo({
      behavior: scrollBehavior ?? "smooth",
      top: element?.offsetTop,
    });
  }, 100);
};
